/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamAgentControlStateResponseData } from './genericApiResponseOralExamAgentControlStateResponseData';
import type { GenericApiResponseOralExamAgentControlStateResponseMessage } from './genericApiResponseOralExamAgentControlStateResponseMessage';
import type { GenericApiResponseOralExamAgentControlStateResponsePagination } from './genericApiResponseOralExamAgentControlStateResponsePagination';
import type { GenericApiResponseOralExamAgentControlStateResponseError } from './genericApiResponseOralExamAgentControlStateResponseError';

export interface GenericApiResponseOralExamAgentControlStateResponse {
  data?: GenericApiResponseOralExamAgentControlStateResponseData;
  message?: GenericApiResponseOralExamAgentControlStateResponseMessage;
  pagination?: GenericApiResponseOralExamAgentControlStateResponsePagination;
  error?: GenericApiResponseOralExamAgentControlStateResponseError;
  statusCode?: number;
}
